import { CURRENCIES, CurrenciesTypes } from 'Types/Currencies'
import { PRODUCT_TYPES, ProductTypes } from 'Types/ProductTypes'

export const OVERAGES = {
  [PRODUCT_TYPES.PAID_MARKETING.toLowerCase()]: {
    [CURRENCIES.USD]: '$0.03',
    [CURRENCIES.AUD]: '$0.045',
    [CURRENCIES.EUR]: '€0.042',
    [CURRENCIES.GBP]: '£0.034',
  },
  [PRODUCT_TYPES.BOT_ZAPPING.toLowerCase()]: {
    [CURRENCIES.USD]: '$0.01',
    [CURRENCIES.AUD]: '$0.015',
    [CURRENCIES.EUR]: '€0.014',
    [CURRENCIES.GBP]: '£0.011',
  },
} as const

export const getOverage = (product: ProductTypes, currency: CurrenciesTypes) =>
  product === PRODUCT_TYPES.BUNDLE ? '' : OVERAGES[product.toLowerCase()][currency]
